import { ChangeDetectionStrategy, Component, ComponentRef, Input } from '@angular/core';
import { enumLclTrackingStates } from '@enum/enumLclTrackingStates';
import { LclQuoteCardModel } from '@data-layer/models/lcl/lcl-quote-card.model';
import { LclShipmentCardModel } from '@data-layer/models/lcl/lcl-shipment-card.model';
import { ActivatedRoute, Router } from '@angular/router';
import { enumShipmentState } from '@data-layer/enums/lcl';
import { LCLShipmentModel } from '@data-layer/models/lcl';
import { enumIncotermsType } from '@app/data-layer/enums/lcl/enumIncotermsType';
import { switchMap, take } from 'rxjs/operators';
import { AppService } from '@app/app.service';
import { Observable, of } from 'rxjs';
import { LclShipmentService } from '@app/modules/lcl-shipping/services/lcl-shipment.service';
import { QuoteRepository, ShipmentRepository } from '@data-layer/repositories';
import { LclEditIncotermsComponent } from '../lcl-edit-incoterms/lcl-edit-incoterms.component';
import { LclQuoteService } from '@app/modules/lcl-shipping/services';

@Component({
  selector: 'mobile-lcl-card',
  templateUrl: './mobile-lcl-card.component.html',
  styleUrls: ['./mobile-lcl-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileLclCardComponent {
  @Input() public info: LclQuoteCardModel | LclShipmentCardModel | LCLShipmentModel;
  @Input() public isShipment: boolean;

  public enumShipmentState: typeof enumShipmentState = enumShipmentState;
  public enumLclTrackingStates: typeof enumLclTrackingStates = enumLclTrackingStates;
  public enumIncotermsType: typeof enumIncotermsType = enumIncotermsType;

  public KG_TON_MULTIPLIER: number = 1000;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private appService: AppService,
    private shipmentRepository: ShipmentRepository,
    private lclShipmentService: LclShipmentService,
    private lclQuoteService: LclQuoteService,
    private quoteRepository: QuoteRepository,
  ) {}

  public bookQuote(): void {
    this.router.navigate([this.info.id, 'booking'], { relativeTo: this.activatedRoute });
  }

  public onEditIncoTerms(): void {
    const componentSidebarRef: ComponentRef<LclEditIncotermsComponent> = this.appService.openSidebar(LclEditIncotermsComponent, {
      sidebarHeaderText: 'PORT_CHARGES',
      tooltipText: 'LABELS.INCOTERMS_HINT',
    });

    componentSidebarRef.instance.shipment = this.info as LCLShipmentModel;
    componentSidebarRef.instance.isHideRoleSelector = this.isShipment;
    componentSidebarRef.instance.dataSaved
      .pipe(
        take(1),
        switchMap((res: { exportLicenseRequested: boolean; incoTermsType: enumIncotermsType }) => this.updateIncoTerms(res)),
        switchMap(() => (!this.isShipment ? this.lclQuoteService.cleanOldEntities() : of(true))),
      )
      .subscribe(() => {
        if (!this.isShipment) {
          this.lclQuoteService.cleanOldEntities();
          this.lclQuoteService.updateLclQuote$.next();
        } else {
          this.lclShipmentService.updateLclShipment$.next();
        }

        this.appService.closeSidebar();
      });
  }

  private updateIncoTerms(updatedData: { exportLicenseRequested: boolean; incoTermsType: enumIncotermsType }): Observable<any> {
    return this.isShipment
      ? this.shipmentRepository.updateIncoterms(this.info.id, updatedData)
      : this.quoteRepository.update({ ...updatedData });
  }
}
